import styled from '@emotion/styled';

export default styled.span<{ selected?: boolean; line?: number }>`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ line }) => line || 1};
  -webkit-box-orient: vertical;
  color: ${({ selected }) => (selected ? '#cccccc' : 'rgb(33, 33, 36)')};
  transition: 0.3s color, 0.3s opacity;
`;
